// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "common" + "." + "a3a3bd7208ed13e9" + ".css";
};